export default __webpack_public_path__ + "static/media/upload.1ffd71b3.svg";